module.exports = __webpack_public_path__ + "static/media/028.6ff61fc0.jpg";